import { createContext, useContext, useState } from "react";

const strings = {
  hi: {
    nav: {
      home: "होम", about: "हमारे बारे में", work: "हमारे कार्य", campaigns: "अभियान",
      impact: "प्रभाव", gallery: "गैलरी", volunteer: "हमारे साथ जुड़ें", donate: "दान करें",
      contact: "संपर्क", faq: "सामान्य प्रश्न", blog: "ब्लॉग", events: "कार्यक्रम", reports: "रिपोर्ट",
      founder: "संस्थापक", videos: "वीडियो",
    },
    top: { reg: "पंजीकरण संख्या", est: "स्थापना वर्ष", contact: "संपर्क" },
    hero: {
      line1: "समस्या से", line2: "समाधान की ओर", line3: "– एक पहल",
      sub: "अंशा वेलफेयर सोसाइटी के साथ मिलकर शिक्षा, स्वास्थ्य, महिला सशक्तिकरण, पर्यावरण संरक्षण और जरूरतमंद लोगों के जीवन में सकारात्मक बदलाव लाने की पहल।",
      cta1: "हमारे कार्य देखें", cta2: "अभी दान करें",
      trust: "पंजीकृत सामाजिक संस्था • स्थापना वर्ष 2025 • जमीनी स्तर पर कार्य",
    },
    common: {
      donateNow: "अभी दान करें", learnMore: "और जानें", viewAll: "सभी देखें",
      send: "संदेश भेजें", submit: "जानकारी भेजें", sending: "भेजा जा रहा है...",
      callNow: "कॉल करें", whatsapp: "WhatsApp करें", emailUs: "ई-मेल करें",
      close: "बंद करें", all: "सभी", videoSoon: "वीडियो जल्द उपलब्ध होगा",
      testimonialSoon: "आपकी प्रतिक्रिया जल्द यहां प्रदर्शित की जाएगी।",
      required: "यह फ़ील्ड आवश्यक है",
      formSuccess: "धन्यवाद! आपकी जानकारी सफलतापूर्वक प्राप्त हो गई है।",
      formError: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
    },
    form: {
      name: "नाम", phone: "मोबाइल नंबर", email: "ईमेल", city: "शहर/जिला",
      interest: "आपकी रुचि", contribution: "आप किस प्रकार सहयोग करना चाहते हैं?",
      message: "संदेश", subject: "विषय",
    },
    donate: {
      title: "आपका छोटा सा सहयोग, किसी के जीवन में बड़ा बदलाव ला सकता है",
      sub: "शिक्षा, स्वास्थ्य, महिला सशक्तिकरण, पर्यावरण और जरूरतमंद लोगों की सहायता के लिए आपका सहयोग महत्वपूर्ण है।",
      online: "ऑनलाइन दान", scanQr: "QR कोड स्कैन करके सुरक्षित रूप से दान करें।",
      qrPlaceholder: "दान QR कोड यहां जल्द उपलब्ध होगा",
      holder: "खाताधारक", account: "खाता संख्या", ifsc: "IFSC", branch: "शाखा",
      accType: "खाता प्रकार", upi: "UPI / VPA", contactL: "संपर्क", emailL: "ई-मेल",
      btn: "दान करें",
      note: "दान करने के बाद रसीद या पुष्टि के लिए संस्था से संपर्क करें।",
      trust: "आपका सहयोग जरूरतमंदों तक पहुंचाने के हमारे प्रयास को मजबूत करता है।",
      warning: "कृपया केवल वेबसाइट पर दिए गए आधिकारिक भुगतान विवरण का ही उपयोग करें।",
      bankTitle: "बैंक ट्रांसफर विवरण",
    },
    footer: {
      about: "अंशा वेलफेयर सोसाइटी एक पंजीकृत सामाजिक संस्था है, जो शिक्षा, स्वास्थ्य, महिला सशक्तिकरण, पर्यावरण संरक्षण और जरूरतमंदों की सहायता के लिए कार्यरत है।",
      quick: "त्वरित लिंक", work: "हमारे कार्य", contact: "संपर्क",
      rights: "© 2025 अंशा वेलफेयर सोसाइटी. सर्वाधिकार सुरक्षित।",
      privacy: "गोपनीयता नीति", terms: "नियम एवं शर्तें", follow: "सोशल मीडिया",
    },
    admin: {
      login: "एडमिन लॉगिन", email: "ईमेल", password: "पासवर्ड", loginBtn: "लॉगिन करें",
      dashboard: "एडमिन डैशबोर्ड", logout: "लॉगआउट",
      messages: "संपर्क संदेश", volunteers: "स्वयंसेवक आवेदन", galleryTab: "गैलरी प्रबंधन", contentTab: "साइट सामग्री",
      addImage: "फोटो जोड़ें", save: "सहेजें", delete: "हटाएं", saved: "सहेजा गया",
      imageUrl: "फोटो URL", captionHi: "शीर्षक (हिंदी)", captionEn: "शीर्षक (English)", category: "श्रेणी",
      noData: "अभी कोई जानकारी नहीं है।",
    },
  },
  en: {
    nav: {
      home: "Home", about: "About Us", work: "Our Work", campaigns: "Campaigns",
      impact: "Impact", gallery: "Gallery", volunteer: "Join Us", donate: "Donate",
      contact: "Contact", faq: "FAQs", blog: "Blog", events: "Events", reports: "Reports",
      founder: "Founder", videos: "Videos",
    },
    top: { reg: "Reg. No.", est: "Established", contact: "Contact" },
    hero: {
      line1: "From Problems", line2: "to Solutions", line3: "– An Initiative",
      sub: "Join Anansha Welfare Society in bringing positive change through education, healthcare, women empowerment, environment protection and support for those in need.",
      cta1: "Explore Our Work", cta2: "Donate Now",
      trust: "Registered social organization • Established 2025 • Grassroots work",
    },
    common: {
      donateNow: "Donate Now", learnMore: "Learn More", viewAll: "View All",
      send: "Send Message", submit: "Submit", sending: "Sending...",
      callNow: "Call Now", whatsapp: "WhatsApp", emailUs: "Email Us",
      close: "Close", all: "All", videoSoon: "Videos coming soon",
      testimonialSoon: "Genuine testimonials will be displayed here soon.",
      required: "This field is required",
      formSuccess: "Thank you! Your information has been received successfully.",
      formError: "Something went wrong. Please try again.",
    },
    form: {
      name: "Name", phone: "Mobile Number", email: "Email", city: "City/District",
      interest: "Your Interest", contribution: "How would you like to contribute?",
      message: "Message", subject: "Subject",
    },
    donate: {
      title: "Your small contribution can bring a big change in someone's life",
      sub: "Your support matters for education, healthcare, women empowerment, environment and helping those in need.",
      online: "Online Donation", scanQr: "Scan the QR code to donate securely.",
      qrPlaceholder: "Donation QR code will be available here soon",
      holder: "Account Holder", account: "Account Number", ifsc: "IFSC", branch: "Branch",
      accType: "Account Type", upi: "UPI / VPA", contactL: "Contact", emailL: "Email",
      btn: "Donate",
      note: "After donating, please contact the organization for receipt or confirmation.",
      trust: "Your contribution strengthens our effort to reach those in need.",
      warning: "Please use only the official payment details given on this website.",
      bankTitle: "Bank Transfer Details",
    },
    footer: {
      about: "Anansha Welfare Society is a registered social organization working for education, healthcare, women empowerment, environment protection and support for the needy.",
      quick: "Quick Links", work: "Our Work", contact: "Contact",
      rights: "© 2025 Anansha Welfare Society. All rights reserved.",
      privacy: "Privacy Policy", terms: "Terms & Conditions", follow: "Social Media",
    },
    admin: {
      login: "Admin Login", email: "Email", password: "Password", loginBtn: "Login",
      dashboard: "Admin Dashboard", logout: "Logout",
      messages: "Contact Messages", volunteers: "Volunteer Applications", galleryTab: "Gallery Management", contentTab: "Site Content",
      addImage: "Add Photo", save: "Save", delete: "Delete", saved: "Saved",
      imageUrl: "Photo URL", captionHi: "Caption (Hindi)", captionEn: "Caption (English)", category: "Category",
      noData: "No data yet.",
    },
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("hi");
  const t = (path) => {
    let cur = strings[lang];
    for (const p of path.split(".")) cur = cur?.[p];
    return cur ?? path;
  };
  const pick = (obj) => (obj ? obj[lang] ?? obj.hi ?? "" : "");
  return (
    <LangContext.Provider value={{ lang, setLang, toggle: () => setLang((l) => (l === "hi" ? "en" : "hi")), t, pick }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
